module.exports = __webpack_public_path__ + "img/stopwatch.31d5401f.svg";